import React, { useEffect, useState } from "react";
import MainBanner from "../../Components/Banner/MainBanner";
import Footer from "../../Components/Footer/Footer";
import Header from "../../Components/Header/Header";
import "../../assets/css/Contact.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope } from "@fortawesome/free-solid-svg-icons";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import ActionButton from "../../Components/ActionBtn/ActionButton";
import { ContactUsApi } from "../../network/Network";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";

function Contactus() {
	const SiteSettingsRedux = useSelector((state) => state.AuthReducer.siteSettings);
	const [firstName, setFirstName] = useState("");
	const [lastName, setLastName] = useState("");
	const [phone, setPhone] = useState("");
	const [email, setEmail] = useState("");
	const [message, setMessage] = useState("");
	const [loading, setLoading] = useState(false);

	const ContactUsHandler = (e) => {
		e.preventDefault();
		setLoading(true);
		if (!firstName || !lastName || !phone || !email || !message) {
			toast.error("Please Enter All Fields");
			setLoading(false);
			return;
		}
		if (
			!/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
				email
			)
		) {
			toast.error("Invalid Email");
			setLoading(false);
			return;
		}
		if (firstName?.length < 3 || firstName.length > 15) {
			toast.error("First name must be at least 3 to 15 characters");
			setLoading(false);
			return;
		}
		if (lastName?.length < 3 || lastName.length > 15) {
			toast.error("Last name must be at least 10 to 17 characters");
			setLoading(false);
			return;
		}
		if (phone?.length < 10 || phone.length > 17) {
			toast.error("The phone no must be at least 10 to 17 digits");
			setLoading(false);
			return;
		}
		if (message.length < 20) {
			toast.error("The message must be at least 20 characters");
			setLoading(false);
			return;
		}
		let data = {
			first_name: firstName,
			last_name: lastName,
			mobile_number: phone,
			email: email,
			message: message,
		};
		ContactUsApi(data)
			.then((res) => {
				toast.success(res?.data?.message);
				setLoading(false);
				setFirstName("");
				setLastName("");
				setPhone("");
				setEmail("");
				setMessage("");
			})
			.catch((err) => {
				setLoading(false);
			});
	};

	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);
	return (
		<>
			<Header />
			<MainBanner name={"Contact us"} />
			<section className="contact-page">
				<div className="container">
					<div>
						<h2 className="main-Title">Let Us Answer All Your Questions </h2>
						<p className="main-para">
							Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
							eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut
							enim ad minim veniam, quis nostrud exercitation ullamco laboris
							nisi ut aliquip ex ea commodo consequat.{" "}
						</p>
					</div>
					<ActionButton />
					<div className="row">
						<div className="col-lg-6">
							<div className="input-div">
								<label>First name*</label>
								<input type="text"
									value={firstName}
									onChange={(e) => setFirstName(e.target.value)}
								/>
							</div>
						</div>
						<div className="col-lg-6">
							<div className="input-div">
								<label>Last name*</label>
								<input type="text"
									value={lastName}
									onChange={(e) => setLastName(e.target.value)}
								/>
							</div>
						</div>
						<div className="col-lg-6">
							<div className="input-div">
								<label>Email*</label>
								<input type="text"
									value={email}
									onChange={(e) => setEmail(e.target.value)}
								/>
							</div>
						</div>
						<div className="col-lg-6">
							<div className="input-div">
								<label>Phone*</label>
								<input type="number"
									value={phone}
									onChange={(e) => setPhone(e.target.value)}
								/>
							</div>
						</div>
						<div className="col-lg-12">
							<div className="input-div">
								<label>Message*</label>
								<textarea rows="4" cols="50"
									value={message}
									onChange={(e) => setMessage(e.target.value)}
								></textarea>
							</div>
						</div>
						<div className="col-lg-12">
							<div className="input-div Contact-page">
								<button className="btn"
									onClick={(e) => ContactUsHandler(e)}
									disabled={loading}
								> {loading ? "Loading.." : "Submit"}</button>
							</div>
						</div>
					</div>

					<div className="row mt-5">
						<div className="col-lg-4 comp-info">
							<div className="icon-cont">
								<FontAwesomeIcon icon={faEnvelope} className="icons-info" />
							</div>
							<div className="content">
								<h2 className="title">Email us</h2>
								<p className="detail">
									Email us for general queries, including marketing and
									partnership opportunities.
								</p>
								<p className="small-info">{SiteSettingsRedux?.hoho_company_email}</p>
							</div>
						</div>
						<div className="col-lg-4 comp-info">
							<div className="icon-cont">
								<i className="fa fa-phone icons-info" aria-hidden="true"></i>
							</div>
							<div className="content">
								<h2 className="title">Call Us</h2>
								<p className="detail">
									Call us to speak to a member of our team. We are always happy
									to help.
								</p>
								<p className="small-info">{SiteSettingsRedux?.hoho_company_phone}</p>
							</div>
						</div>
						<div className="col-lg-4 comp-info">
							<div className="icon-cont">
								{/* <FontAwesomeIcon icon={faEnvelope} className="icons-info" /> */}
								<LocationOnIcon className="icons-info" />
							</div>
							<div className="content">
								<h2 className="title">Our Head Office</h2>
								<p className="detail">
									{SiteSettingsRedux?.hoho_company_address}
								</p>
							</div>
						</div>
					</div>
				</div>
			</section>
			<Footer />
		</>
	);
}

export default Contactus;
